var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Вы уверены, что хотите закрыть счет на сумму "),_c('strong',[_vm._v(_vm._s(_vm.balance))]),_vm._v(" под номером: "),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.invoice))])])}
var staticRenderFns = []

export { render, staticRenderFns }